

import {GET_ScriptPath} from '../constants/ActionTypes'

const INIT_STATE = {
    scriptPath: null,
    loading: false
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_ScriptPath:
            return {
                scriptPath: action.body,
                loading :false
            }
        default:
            return state;
    }
}